import { createTheme, responsiveFontSizes } from '@mui/material'
import { Fragment } from 'react/jsx-runtime'

const insee = createTheme({
  palette: {
    primary: { main: '#F2F2F2' },
    secondary: { main: '#A92B40' },
    error: { main: '#e57373' },
    warning: { main: '#ffb74d' },
    info: { main: '#64b5f6' },
    success: { main: '#81c784' },
    canvas: { main: '#F7F7F7' },
    selected: { cadre: '#9F0B39', texte: '#F7F7F7' },
    hover: { cadre: '#DA778C' }
  } as never,
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&.Mui-focused': {
            backgroundColor: '#F5B8C2 !important'
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        slotProps: {
          input: {
            slots: {
              // Pour comprendre cette ligne, voir le commentaire de la fonction renderInputAccessibleGenerator
              notchedOutline: Fragment
            }
          }
        }
      }
    }
  }
})

export const InseeTheme = responsiveFontSizes(insee)
